import { type DatabaseJSON } from '@databases/model/database';

import { waitForContentAPI } from '@canvas/frame-api/host-api/host-frame-context';

import {
  getEntriesCount,
  getFieldsCount,
  getFilledCellsCount
} from './database-size/resolvers';

/**
 * Reports raw database content-creation progress (rows, columns, filled cells)
 * to the Confluence host so it can evaluate whether to show the "Flag to Share"
 * onboarding nudge (TWCG-2055). Canvas reports counts only; Confluence owns the
 * threshold, inactivity timer, experiment eligibility, and rendering.
 */
export const reportDatabaseShareProgress = async (
  database: DatabaseJSON
): Promise<void> => {
  try {
    const contentApi = await waitForContentAPI();
    const notifyShareCriteriaProgress =
      contentApi.confluenceAPI?.onboarding?.notifyShareCriteriaProgress;

    if (!notifyShareCriteriaProgress) {
      return;
    }

    notifyShareCriteriaProgress({
      type: 'database',
      rows: getEntriesCount(database),
      columns: getFieldsCount(database),
      filledCells: getFilledCellsCount(database)
    });
  } catch (e) {
    console.error('Failed to report database share progress:', e);
  }
};
